/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_BadgeInputs */

const en_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const de_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen`)
};

const fr_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalités`)
};

const es_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funcionalidades`)
};

const it_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalità`)
};

const nl_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functies`)
};

const pl_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje`)
};

const fi_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ominaisuudet`)
};

const da_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioner`)
};

const sv_landing_features_badge = /** @type {(inputs: Landing_Features_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioner`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Landing_Features_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_features_badge = /** @type {((inputs?: Landing_Features_BadgeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_BadgeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_features_badge(inputs)
	if (locale === "fr") return fr_landing_features_badge(inputs)
	if (locale === "es") return es_landing_features_badge(inputs)
	if (locale === "it") return it_landing_features_badge(inputs)
	if (locale === "nl") return nl_landing_features_badge(inputs)
	if (locale === "pl") return pl_landing_features_badge(inputs)
	if (locale === "fi") return fi_landing_features_badge(inputs)
	if (locale === "da") return da_landing_features_badge(inputs)
	if (locale === "sv") return sv_landing_features_badge(inputs)
	return en_landing_features_badge(inputs)
});